import { FormState } from '../../states/kyc-form-state';
import {
  load,
  upload,
  getCustomerDocument,
  saveKyc,
  loadSettlement,
  getCustomerFile,
} from '../../controllers/KycController';

import { signal } from '@preact/signals';

import Store from '../../stores/Store';

import KycPayload from '../../classes/KycPayload';
import { route } from 'preact-router';

import { GlobalState } from '../../states/global-state';
import {
  KycLoadResponseType,
  KycLoadDataType,
  SettlementLoadDataType,
} from '../../types/types';
import { blobToUrl, showAlert } from '../../utils';
import { RefreshSession } from '../../components/socket';

export const plot = data => {
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      const value = data[key];
      if (FormState.formControlValues[key]) {
        FormState.formControlValues[key].value = value;
      }
    }
  }
};

export const getDocument = async type => {
  const doc = await getCustomerDocument(type);
  if (doc) {
    const url = doc.file;
    const fileKey = doc.fileKey;

    await getCustomerFile(url).then(arrayBuffer => {
      const arr = new Uint8Array(arrayBuffer);
      const blob = new Blob([arr], { type: 'application/pdf' });

      const url = blobToUrl(blob);
      // console.log(48, url);

      FormState.formControlValues[`blob-url-${type}`].value = url;
    });

    return doc.fileKey;
  }
};

export const setUpControls = controls => {
  const ctrl = controls.map((item: any, index) => {
    const { name, tag, controls } = item;

    if (controls) {
      for (const key in controls) {
        if (Object.prototype.hasOwnProperty.call(controls, key)) {
          const item = controls[key];

          if (!['origin'].includes(tag)) {
            FormState.formControlValues[item.name] = signal('');
            item.value = FormState.formControlValues[item.name];
          }

          item['id'] = `${index}-${item.name || tag}`;
          controls[key] = item;
        }
      }
    } else {
      /**
       * input type file is not subscribe to value;
       */
      if (item.type == 'file') {
        FormState.formControlValues[`blob-url-${item.name}`] = signal('');

        item.blobUrl = FormState.formControlValues[`blob-url-${item.name}`];
      } else if (!['address-checkbox'].includes(tag)) {
        FormState.formControlValues[item.name] = signal('');
        item.value = FormState.formControlValues[item.name];
      }

      // item['id'] = `${config.name}-${index}-${item.name}`;
      item['id'] = `${index}-${item.name}`;
    }

    return item;
  });

  // console.log(FormState.formControlValues);
  return ctrl;
};

export const submitForm = async ({
  e,
  formValidation,
  formConfig,
  episodeIndex,
  nextEpisode,
}) => {
  const store = new Store();

  const valid = await formValidation.validate('.input');

  if (!valid) {
    return;
  }

  const config = formConfig.current;

  const data = config['getFormData'](e.target);

  const cloned = { ...data };
  if (config['files']) {
    config['files'][0] && delete cloned[config['files'][0]];
    config['files'][1] && delete cloned[config['files'][1]];
  }

  store.setFormData(cloned);

  if (config['files']) {
    const files = config['files'].reduce((accu, type) => {
      const value = data[type];
      const file = typeof value == 'string' ? null : value;

      if (file) {
        accu.push({ type, file });
      }

      return accu;
    }, []);

    // console.log(137, files);

    if (files[0]) {
      const type = files[0].type;
      const doc = await upload(type, files[0].file);

      if (doc.code == 0) {
        getDocument(type);
      }
    }

    if (files[1]) {
      const type = files[1].type;
      const doc = await upload(type, files[1].file);

      if (doc.code == 0) {
        getDocument(type);
      }
    }
  }

  let payload = null;
  try {
    store.getFormData(null, datas => {
      payload = new KycPayload(datas);

      // route(nextEpisode.current);
    });
  } catch (err) {
    console.log(err);
    /**
     * it will error if the required datas is not completed,
     * the error comes from KycPayload which means,
     * that there is no api call happening here;
     *
     * RefreshSession must be called from here
     *
     */
    RefreshSession(response => '');

    if (err.message == 'required kyc data is not complete') {
      route(nextEpisode.current);
    }
    return;
  }

  if (!payload) {
    console.log('payload is null');
    return;
  }

  // console.log(290, payload.data);

  const saved = await saveKyc<{
    code: number;
    info: string;
  }>(payload.data);

  // console.log(246, saved);

  if (saved.code == 0) {
    ///error in payload
    showAlert({
      title: 'Error',
      icon: 'error',
      text: saved.info,
    });
  } else if (saved.code == 22) {
    //no middlename error/ not saved
    GlobalState.set.showModal(true, {
      text: saved.info,
      showNegativeBtn: false,
      positiveCallback: () => {
        console.log('here');
      },
    });
  } else if (saved.code == 1) {
    //success
    showAlert({
      title: 'Success',
      icon: 'success',
      text: saved.info,
    });
  } else if (saved.code == 2) {
    //proceed to fatca
    GlobalState.set.showModal(true, {
      text: saved.info,
      showNegativeBtn: false,
      positiveCallback: () => {
        route('/fatca', true);
      },
    });
  } else if (saved.code == 100) {
    //invalid token
    showAlert({
      title: 'Error',
      icon: 'error',
      text: saved.info,
    });
  }
};

export const plotAndCacheFormData = async ({ config, episodeIndex }) => {
  const store = new Store();
  const items = await store.getProfileData();

  if (episodeIndex.current == 0 && config['files']) {
    getDocument(config['files'][0]);
    getDocument(config['files'][1]);
  }

  GlobalState.kycLoad.value = items as KycLoadDataType;
  GlobalState.settlementLoad.value = items as SettlementLoadDataType;
  plot(items);
};

export const isSelectedCustomerAnswer = (optionValue, selectedOption) => {
  if (selectedOption == undefined) {
    return { selected: false };
  }

  if (
    selectedOption.constructor.name != 'Number' &&
    selectedOption.constructor.name == 'Array' &&
    !selectedOption.length
  ) {
    return { selected: false };
  } else if (
    selectedOption.constructor.name != 'Number' &&
    selectedOption.constructor.name == 'String' &&
    !selectedOption.length
  ) {
    return { selected: false };
  }

  let selected = false;
  let questionId, answerId, answerScore;
  if (optionValue.includes && optionValue.includes('_')) {
    const splitted = optionValue.split('_');

    questionId = splitted[0];
    answerId = splitted[1];
    answerScore = splitted[2];

    if (
      //for riskprofile select;
      typeof selectedOption == 'number'
    ) {
      selected = selectedOption == Number(answerId);
    }
    //for riskprofile checkbox;
    else if (selectedOption.constructor.name == 'Array') {
      selected = selectedOption.includes(Number(answerId));
    }
  }
  //setup for fatca questions
  else {
    selected = selectedOption == optionValue;
  }

  // console.log(301, selected);
  // console.trace();

  return { selected, questionId, answerId, answerScore };
};
